import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import _ from 'lodash'; // import cx from 'classnames'

import { useSelector, useDispatch } from 'react-redux';
import { TablePagination } from '@material-ui/core';
import DataTable from '../ui/table';
import Card from '../ui/card';
import TrafficGateChart from './traffic-gate-chart'; // Api

import { getAreaGates } from '../../api/areaAPI'; // Redux

import { setGatesData, setGatesSort } from '../../redux/traffic-prediction';
var t = i18n.getFixedT(null, 'traffic-prediction');
var gt = i18n.getFixedT(null, 'app');
var TrafficGates = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$trafficP = _useSelector.trafficPrediction,
      gatesSort = _useSelector$trafficP.gatesSort,
      gatesData = _useSelector$trafficP.gatesData,
      gatesTotalCount = _useSelector$trafficP.gatesTotalCount,
      gatesChartData = _useSelector$trafficP.gatesChartData;

  var dispatch = useDispatch();

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      tableData = _useState2[0],
      setTableData = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      currentPage = _useState4[0],
      setCurrentPage = _useState4[1];

  var _useState5 = useState(10),
      _useState6 = _slicedToArray(_useState5, 2),
      rowsPerPage = _useState6[0],
      setRowsPerPage = _useState6[1];

  var id = props.id;
  var isMounted = useRef(false);

  var handleSort = function handleSort(sort) {
    dispatch(setGatesSort(sort));
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(e) {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
  };

  var handleSortData = function handleSortData(d, sort) {
    var field = sort.field,
        desc = sort.desc;

    var newData = _.orderBy(d, [field], [desc ? 'desc' : 'asc']);

    return _.map(newData, function (el, index) {
      return _objectSpread(_objectSpread({}, el), {}, {
        sequence: index + 1
      });
    });
  };

  var handleData = function handleData() {
    var offset = (Number(currentPage + 1) - 1) * rowsPerPage;
    var newData = handleSortData(gatesData, gatesSort);
    newData = _.slice(newData, offset, offset + rowsPerPage);
    setTableData(newData);
  };

  var fetchGates = function fetchGates() {
    var offset = (Number(currentPage + 1) - 1) * rowsPerPage;
    getAreaGates(contextRoot, false, null, gatesSort, offset, rowsPerPage).then(function (result) {
      var newData = _.cloneDeep(result.content);

      _.map(newData, function (el, index) {
        el.sequence = offset + index + 1;
      });

      dispatch(setGatesData(newData));
    });
  };

  useEffect(function () {
    if (isMounted.current === false) return;
    handleData();
  }, [JSON.stringify(gatesSort), currentPage, rowsPerPage]);
  useEffect(function () {
    handleData();
  }, [JSON.stringify(gatesData)]);
  useEffect(function () {
    if (!isMounted.current) {
      isMounted.current = true;
    }
  }, []);
  var statusLevels = ['low', 'middle', 'high'];
  var fields = {};

  _.set(fields, 'sequence', {
    label: t('lbl-sequence')
  });

  _.set(fields, 'name', {
    label: t('lbl-gates'),
    sortable: true
  });

  _.set(fields, 'estVisitDuration', {
    label: t('lbl-prediction-working-time'),
    sortable: true,
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("div", {
        className: "duration-div"
      }, val === -1 ? t('lbl-no-data') : val + "分");
    }
  });

  _.set(fields, 'congestionStatus', {
    label: t('lbl-status'),
    sortable: true,
    formatter: function formatter(val, row) {
      if (parseInt(row.speed) === -1) return t('lbl-no-data');
      return /*#__PURE__*/React.createElement("span", {
        className: statusLevels[row.congestionStatus - 1]
      }, row.congestionStatusName);
    }
  });

  _.set(fields, 'updatedAt', {
    label: t('lbl-update-time'),
    sortable: true
  });

  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: "mb9"
  }, /*#__PURE__*/React.createElement("div", {
    className: "live-traffic c-border c-position-rlt"
  }, /*#__PURE__*/React.createElement(DataTable, {
    fields: fields,
    data: tableData,
    sort: gatesSort,
    onSort: handleSort
  }), /*#__PURE__*/React.createElement(TablePagination, {
    component: "div",
    labelRowsPerPage: gt('global.lbl-per-page-row-count'),
    count: gatesTotalCount,
    page: currentPage,
    onChangePage: function onChangePage(e, newPage) {
      return setCurrentPage(newPage);
    },
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  })), /*#__PURE__*/React.createElement(Card, {
    title: t('lbl-prediction-gates-working-time'),
    enableFullScreen: true
  }, !_.isEmpty(gatesChartData) ? /*#__PURE__*/React.createElement(TrafficGateChart, {
    gatesChartData: gatesChartData
  }) : /*#__PURE__*/React.createElement("div", null)));
});
TrafficGates.defaultProps = {
  id: 'g-traffic-gates'
};
TrafficGates.propTypes = {
  id: PropTypes.string
};
export default TrafficGates;